























































import Vue from 'vue'
import NumberField from '@/components/NumberField.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

interface ComponentData {
  loading: boolean
  validationRules: Function[]
  menu1: boolean
  date: string
  dateFormatted: string | null
  nullableDateRules: any[]
}

export default Vue.extend({
  name: 'KanbanChangeDialog',

  components: {
    NumberField,
    WarningDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''

    return {
      loading: false,
      validationRules: [required],
      menu1: false,
      date: '',
      dateFormatted: '',
      nullableDateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        }
      ],
    }
  },

  watch : {
    dateFormatted (newVal: string | null): void {
      if(newVal) {
        this.date = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.date = ''
      }
    },
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    onDateChange (date: string): void {
      this.dateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurDate (): void {
      this.dateFormatted = moment(this.date).isValid() ?  moment(this.date).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        this.$emit('close')
        //this.showWarningDialog = true
      }
    },

    onWarningDialogClose (): void {
      //this.showWarningDialog = false
    },

    onWarningDialogSave (): void {
      //this.showWarningDialog = false
      this.$emit('save')
    },
  }
})
